<ng-container *ngIf="showModal; else debugPanel">
    <dialog class="debug-modal">
        <form method="dialog">
            <button type="submit" autofocus class="close-button">
                <finder-font-icon name="icon_close-reversed" size="s"></finder-font-icon>
            </button>
        </form>
        <ng-container *ngTemplateOutlet="debugPanel"></ng-container>
    </dialog>
</ng-container>

<ng-template #debugPanel>
    <div class="debug-panel" *ngIf="showPanel">
        <hr aria-hidden="true" *ngIf="!showModal" />
        <div class="debug-header">
            <h2>Debug Panel</h2>
            <p *ngIf="pageType"><label>Page Type:</label> {{pageType}}</p>
            <p *ngIf="entityId"><label>Entity Id:</label> {{entityId}}</p>
            <p *ngIf="entityType"><label>Entity Type:</label> {{entityType}}</p>
            <p *ngIf="location"><label>Location:</label> {{location}}</p>
            <p *ngIf="urlFriendly"><label>URL Friendly Id:</label> {{urlFriendly}}</p>
            <p *ngIf="conversationUUID"><label>Conversation UUID:</label> {{conversationUUID}}</p>
            <p class="squirt-btn">
                <finder-button theme="primary" (click)="loadSquirt()">Check Images</finder-button>
            </p>
        </div>
        <div class="debug-json" *ngIf="showEditor">
            @defer {
                <finder-json-editor [data]="svcResponse"></finder-json-editor>
            }
        </div>
        <div class="language-selector">
            <finder-language-selector></finder-language-selector>
        </div>
        <div class="debug-log">
            <p><strong>Debug Log</strong></p>
            <!-- This alignment is on purpose so the pre content doesn't have silly indentations -->
            <pre><ng-container *ngFor="let output of debugLogOutput">{{output}}</ng-container></pre>
        </div>
    </div>
</ng-template>
